import { render, staticRenderFns } from "./SignUp.vue?vue&type=template&id=632eb242&scoped=true"
import script from "./SignUp.vue?vue&type=script&lang=js"
export * from "./SignUp.vue?vue&type=script&lang=js"
import style0 from "./SignUp.vue?vue&type=style&index=0&id=632eb242&lang=less&scoped=true"
import style1 from "./SignUp.vue?vue&type=style&index=1&id=632eb242&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "632eb242",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/saas_fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('632eb242')) {
      api.createRecord('632eb242', component.options)
    } else {
      api.reload('632eb242', component.options)
    }
    module.hot.accept("./SignUp.vue?vue&type=template&id=632eb242&scoped=true", function () {
      api.rerender('632eb242', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/login/SignUp.vue"
export default component.exports